import { ReviewListFilter } from 'modules/review/review.interface';
import { ApiSortingDirection } from 'interfaces/api.interface';
import { ReviewListParamsItem } from 'modules/review/review-query-params.interface';

export const initialReviewListParams = (queryParams: ReviewListParamsItem): ReviewListFilter => {
    const initialParams: ReviewListFilter = {
        sortingField: queryParams.sorting?.field || 'createdAt',
        sortingDirection: queryParams.sorting?.direction || ApiSortingDirection.desc
    };

    if (queryParams.rating) {
        initialParams.rating = queryParams.rating;
    }

    if (queryParams.pagination) {
        initialParams.offset = queryParams.pagination.offset;
        initialParams.limit = queryParams.pagination.limit;
    }

    return initialParams;
};
